import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import api from "../../../api/axiosInterceptor";
import { API_BASE_URL } from "../../../config";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";

export default function FECAClaimsCACounts() {
  const [counts, setCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const showSnackbar = (msg, sev = "info") =>
    setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const fetchCounts = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/claim-mgmt/ca-claim_summary/`
      );
      setCounts(res.data);
    } catch (err) {
      console.error("Error fetching FE CA Claims CA Counts", err);
      showSnackbar("Failed to load counts data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "center",
          background: "linear-gradient(90deg, #2563EB, #10B981, #F59E0B)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)"
        }}
      >
        FE Claims - CA Summary
      </Typography>

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: "50vh" }}
        >
          <CircularProgress size={60} />
        </Box>
      ) : counts.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography>No data available</Typography>
        </Paper>
      ) : (
        <Card sx={{ borderRadius: 3, boxShadow: 5 }}>
          <CardContent>
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#2563EB" }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Financial Establishment
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Total Assigned
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Total Verified By Me
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Total Rejected By Me
                    </TableCell>
                    {/* <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Not Settled
                    </TableCell> */}
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Today Verified By Me
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Today Rejected By Me
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Today Settled By Me
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {counts.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{row.fe_name}</TableCell>
                      <TableCell align="center">{row.total_assigned}</TableCell>
                      <TableCell align="center">{row.total_verified_by_me}</TableCell>
                      <TableCell align="center">{row.total_rejected_by_me}</TableCell>
                      {/* <TableCell align="center">{row.not_settled}</TableCell> */}
                      <TableCell align="center">{row.today_verified_by_me}</TableCell>
                      <TableCell align="center">{row.today_rejected_by_me}</TableCell>
                      <TableCell align="center">{row.today_settled_by_me}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />
    </Box>
  );
}
